import { render, staticRenderFns } from "./IdleReport.vue?vue&type=template&id=7635e5bc&"
import script from "./IdleReport.vue?vue&type=script&lang=js&"
export * from "./IdleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports